import { IDeliveryDate } from '../types'

const months: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const days: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const phrases: string[] = ['today', 'tomorrow', 'in 2 days', 'in 3 days', 'in 3+ days']

export function getRandomDate(): IDeliveryDate {
  const randomIndex = Math.floor(Math.random() * phrases.length)
  const phrase = phrases[randomIndex]

  const today = new Date()
  const targetDate = new Date(today)

  switch (phrase) {
    case 'today':
      break
    case 'tomorrow':
      targetDate.setDate(today.getDate() + 1)
      break
    case 'in 2 days':
      targetDate.setDate(today.getDate() + 2)
      break
    case 'in 3 days':
      targetDate.setDate(today.getDate() + 3)
      break
    case 'in 3+ days':
      targetDate.setDate(today.getDate() + 4)
      break
  }

  const formattedDate = `${days[targetDate.getDay()]}, ${months[targetDate.getMonth()]} ${targetDate.getDate()}`

  return {
    phrase,
    date: formattedDate,
    originalDate: targetDate
  }
}
